import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Notulen from '@/components/Notulen'
import NotulenForm from '@/components/NotulenForm'
import Task from '@/components/Task'
import Form from '@/components/Form'
import History from '@/components/History'
import HistoryUser from '@/components/HistoryUser'
import Laporan from '@/components/Laporan'
import Notifikasi from '@/components/Notifikasi'
import Profil from '@/components/Profil'
import PenilaianManajemen from '@/components/PenilaianManajemen'
import PenilaianManajemenDetail from '@/components/PenilaianManajemenDetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/notulen',
      name: 'Notulen',
      component: Notulen
    },
    {
      path: '/notulen/:id',
      name: 'NotulenForm',
      component: NotulenForm
    },
    {
      path: '/task',
      name: 'Task',
      component: Task
    },
    {
      path: '/add',
      name: 'Form',
      component: Form
    },
    {
      path: '/profil',
      name: 'Profil',
      component: Profil
    },
    {
      path: '/detail/:id',
      name: 'Form',
      component: Form
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/notifikasi',
      name: 'Notifikasi',
      component: Notifikasi
    },
    {
      path: '/user/:id',
      name: 'History User',
      component: HistoryUser
    },
    {
      path: '/laporan',
      name: 'Laporan',
      component: Laporan
    },
    {
      path: '/penilaian-manajemen',
      name: 'PenilaianManajemen',
      component: PenilaianManajemen
    },
    {
      path: '/penilaian-manajemen/:id_manajemen',
      name: 'PenilaianManajemenDetail',
      component: PenilaianManajemenDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js